import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';

import actions from 'state/loads/actionCreators';
import initialState, {
  emptyLoad,
  initialStateForTest,
} from 'state/loads/initial.state';

const loadHandlers = {
  [actions.changeLoadValues]: (state, { payload: { values } }) => ({
    ...state,
    ...values,
  }),
  [actions.addLoad]: (state, { payload: { loadKey, values } }) => ({
    ...emptyLoad,
    loadKey,
    ...values,
  }),
};

const reducerItemOptions = {
  handlers: loadHandlers,
  key: 'loadKey',
};

const load = (state, action, forAll = false) =>
  reducersUtils.reducerItem(state, action, { ...reducerItemOptions, forAll });

const loads = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.addLoad]: (state, action) => ({
      ...state,
      [action.payload.loadKey]: load(undefined, action),
    }),
    [actions.removeLoad]: (state, { payload: { loadKey } }) =>
      Object.keys(state).length <= 1
        ? { ...state }
        : { ...reducersUtils.removeKeyFrom.object(state, loadKey) },
    [actions.changeLoadValues]: (state, action) => ({
      ...state,
      [action.payload.loadKey]: load(state[action.payload.loadKey], action),
    }),
    [actions.setForTest]: () => ({ ...initialStateForTest }),
  },
  initialState
);

export default loads;
